var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 53.3335H79.1667",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60.668H86.6667",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102.668H103.333",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 110H80",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6667 110L95.0001 110",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.6667,
    cy: 81.6665,
    r: 13.3333,
    stroke: "#FF6C6C",
    strokeWidth: 3.33333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6667 76.6665L86.6667 86.6665",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6667 76.6665L76.6667 86.6665",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50 95V116.667C50 120.349 52.9848 123.333 56.6667 123.333H58.3333M113.333 95V116.667C113.333 120.349 110.349 123.333 106.667 123.333H65",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.333 68.3332V61.0946C113.333 59.3265 112.631 57.6308 111.381 56.3806L96.6667 41.6665M50 68.3332V48.3332C50 44.6513 52.9848 41.6665 56.6667 41.6665H81.6667M96.6667 41.6665V51.6665C96.6667 55.3484 99.6514 58.3332 103.333 58.3332H105M96.6667 41.6665H88.3333M113.333 74.9998V78.3332M50 84.9998V88.3332M50 74.9998V78.3332M113.333 84.9998V88.3332",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDocumentIcon);
export default __webpack_public_path__ + "static/media/red-document-icon.849a3b23.svg";
export { ForwardRef as ReactComponent };